module.exports = __webpack_public_path__ + "static/flash-promo-text-dbe49d2323b99c43fd27cea4079a5c39.svg";